/**
 * @generated SignedSource<<eeca443b05c6ad49f4ab4e7a8c76a8bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightEdit_flight$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FlightEditGeneralInfo_flight" | "FlightEditPriceHistory_flight">;
  readonly " $fragmentType": "FlightEdit_flight";
};
export type FlightEdit_flight$key = {
  readonly " $data"?: FlightEdit_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightEdit_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightEdit_flight",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightEditGeneralInfo_flight"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightEditPriceHistory_flight"
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "68f3e1ac5bad29952ecad76f1e9b64f5";

export default node;
